import { motion } from "framer-motion";
import { Phone, MessageCircle, MapPin, Instagram, ArrowUpRight } from "lucide-react";
import {
  BRAND,
  PHONE,
  PHONE_DISPLAY,
  WA_URL,
  MAP_EMBED,
  MAP_LINK,
  INSTAGRAM,
} from "./data";
import SectionHeader from "./SectionHeader";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[color:var(--forest)] text-[color:var(--paper)]"
    >
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-16 sm:py-20 lg:py-24">
        <SectionHeader
          eyebrow="Section 07 · Booking & Contact Us"
          title={
            <>
              Find us in the <span className="font-display-italic text-[color:var(--sand)]">fog</span>.
            </>
          }
          intro="Call, message on WhatsApp, or drop a pin — we'll help you plan the stay."
          invert
        />

        <div className="mt-12 sm:mt-16 grid grid-cols-12 gap-6 lg:gap-10">
          <div className="col-span-12 lg:col-span-5 flex flex-col gap-8">
            <div className="border-t border-[color:var(--line-inv)] pt-6">
              <div className="font-mono-alt text-[color:var(--paper)]/60 mb-2">
                Address
              </div>
              <p className="font-display text-[1.35rem] leading-tight">
                {BRAND.address}
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <a
                data-testid="contact-call"
                href={`tel:+${PHONE}`}
                className="group flex flex-col gap-2 border-t border-[color:var(--line-inv)] pt-6 hover:text-[color:var(--sand)] transition-colors"
              >
                <div className="flex items-center gap-2 font-mono-alt text-[color:var(--paper)]/60">
                  <Phone size={12} /> Phone
                </div>
                <div className="font-display text-[1.2rem] flex items-center gap-2">
                  {PHONE_DISPLAY}
                  <ArrowUpRight size={16} className="opacity-70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </a>
              <a
                data-testid="contact-whatsapp"
                href={WA_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col gap-2 border-t border-[color:var(--line-inv)] pt-6 hover:text-[color:var(--sand)] transition-colors"
              >
                <div className="flex items-center gap-2 font-mono-alt text-[color:var(--paper)]/60">
                  <MessageCircle size={12} /> WhatsApp
                </div>
                <div className="font-display text-[1.2rem] flex items-center gap-2">
                  {PHONE_DISPLAY}
                  <ArrowUpRight size={16} className="opacity-70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </a>
              <a
                data-testid="contact-instagram"
                href={INSTAGRAM}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col gap-2 border-t border-[color:var(--line-inv)] pt-6 hover:text-[color:var(--sand)] transition-colors"
              >
                <div className="flex items-center gap-2 font-mono-alt text-[color:var(--paper)]/60">
                  <Instagram size={12} /> Instagram
                </div>
                <div className="font-display text-[1.2rem] flex items-center gap-2">
                  @hashtag_sakleshpura
                  <ArrowUpRight size={16} className="opacity-70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </a>
              <a
                data-testid="contact-map"
                href={MAP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex flex-col gap-2 border-t border-[color:var(--line-inv)] pt-6 hover:text-[color:var(--sand)] transition-colors"
              >
                <div className="flex items-center gap-2 font-mono-alt text-[color:var(--paper)]/60">
                  <MapPin size={12} /> Location
                </div>
                <div className="font-display text-[1.2rem] flex items-center gap-2">
                  Open in Maps
                  <ArrowUpRight size={16} className="opacity-70 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </a>
            </div>

            <a
              data-testid="contact-book-cta"
              href={WA_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary self-start"
            >
              Book on WhatsApp <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <div className="relative aspect-[4/3] lg:aspect-[5/4] w-full overflow-hidden rounded-[24px] ring-1 ring-[color:var(--line-inv)] bg-[color:var(--ink)]">
              <iframe
                title="Hashtag Sakleshpura Homestay location"
                data-testid="map-iframe"
                src={MAP_EMBED}
                className="absolute inset-0 h-full w-full"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
